import React from "react";


const TitleHeader = ( {data} ) => {
    return(
        <span className="md:text-[40px] text-[24px] font-medium lg:w-[78%] md:w-[60%] lg:mr-0 md:mr-32 w-[80%] leading-tight" 
                style={{color: data.color}}
            >
            {data.description}
        </span>
    );
};

export default TitleHeader;